import { render, staticRenderFns } from "./OverdraftProvisioning.vue?vue&type=template&id=6cfa5ea6&"
import script from "./OverdraftProvisioning.vue?vue&type=script&lang=js&"
export * from "./OverdraftProvisioning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports